import moment from 'moment';
import _ from 'underscore';

export const VALUE_TYPE = {
	BASIC: 'basic',
	DATE: 'date',
	ASSOCIATED: 'associated',
	STATUS: 'status',
	TAGS: 'tags',
	SUPER_DEFINED: 'super_defined',
};

// TODO - Move this to src/utils and have DatePicker.vue use that too
export function formattedDate(value) {
	if (moment.isMoment(value)) {
		if (!value.isValid()) return null;
		value = value.toDate();
	}

	if (value instanceof Date) {
		return value.toLocaleDateString('en-US', {
			month: '2-digit', day: '2-digit', year: 'numeric',
		});
	}

	return value;
}

export function getOperandsByType(type) {
	switch (type) {
		case 'status':
			return [
				{ value: '=', label: 'is Active' },
				{ value: '!=', label: 'is Not Active' },
			];
		case 'date':
			return [
				{ value: '=', label: 'is equal to' },
				{ value: '!=', label: 'is not equal to' },
				{ value: '<', label: 'is before' },
				{ value: '<=', label: 'is on or before' },
				{ value: '>', label: 'is after' },
				{ value: '>=', label: 'is on or after' },
				{ value: 'between', label: 'is between' },
			];
		case 'tags':
		case 'associated_module':
			return [
				{ value: 'all', label: 'contains all of these:' },
				{ value: 'any', label: 'contains at least one:' },
			];
		case 'wysiwyg':
		case 'static':
		case 'numeric':
		case 'string':
		default:
			return [
				{ value: '=', label: 'is equal to' },
				{ value: '!=', label: 'is not equal to' },
				{ value: 'empty', label: 'is empty' },
				{ value: 'not empty', label: 'is not empty' },
				{ value: 'LIKE', label: 'contains' },
				{ value: 'NOT LIKE', label: 'does not contain' },
			];
	}
}

export function filterDescription(module, filter, filterRelations, withFieldName = false) {
	const operands = _.indexBy(getOperandsByType(filter.type), 'value');
	let operand = filter.operand;
	if (typeof operands[operand] !== 'undefined') {
		operand = operands[operand].label;
	}

	const fieldsBySlug = _.indexBy(module.fields, 'slug');
	const filterField = fieldsBySlug[ filter.field ];

	let arrayJoinSeparator = ' and ';

	const valueFormatter = (value) => {
		switch (filter.type) {
			case 'date':
				return formattedDate(moment(value));
			case 'associated_module': {
				if (filterField) {
					const templateValue = filterRelations.associatedModules[ `v_${filterField.id}` ];
					if (templateValue && templateValue[value]) {
						arrayJoinSeparator = ', ';
						value = templateValue[value];
					}
				}

				return value;
			}
			case 'tags': {
				// const associatedField = fieldsBySlug[ filter.field ];
				// if (associatedField) {
				// 	value = filterRelations.associatedModules[ `v_${associatedField.id}` ];
				// }

				return value;
			}
		}

		return value;
	};

	let value = filter.value;
	if (Array.isArray(value)) {
		value = value.map(valueFormatter);
		value = value.join(arrayJoinSeparator);
	} else {
		value = valueFormatter(value);
	}

	if (value === null) {
		value = '';
	}

	return `${(withFieldName && filterField) ? `<i>${filterField.name}</i> ` : ''}${operand} ${value}`;
}
